var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMagalu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.0639 0H5.93439C2.65729 0 0 2.65729 0 5.93439V26.0656C0 29.3427 2.65729 32 5.93439 32H26.0656C29.3427 32 32 29.3427 32 26.0656V5.93439C31.9983 2.65729 29.341 0 26.0639 0Z",
    fill: "#0F89FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5467 7.10493C25.4711 6.30539 25.0529 5.92578 24.292 5.92578H22.2764C21.6297 5.92578 21.1728 6.19117 20.8301 6.76227L15.9237 15.0566L11.3583 6.76395C11.0543 6.19285 10.5588 5.92746 9.91207 5.92746H7.74525C6.98435 5.92746 6.5661 6.30707 6.49052 7.10661L5.23578 22.323C5.16019 23.1595 5.57844 23.5778 6.3763 23.5778H8.81019C9.57109 23.5778 10.028 23.1965 10.0649 22.3986L10.5974 13.8775L13.5268 19.1652C13.8308 19.7363 14.3263 20.0017 14.973 20.0017H16.646C17.2927 20.0017 17.7496 19.7732 18.0922 19.1652L21.4012 13.4979L21.7825 22.3986C21.8212 23.1982 22.2394 23.5778 23.0003 23.5778H25.6257C26.4252 23.5778 26.8435 23.1595 26.7662 22.323L25.5467 7.10493Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.8552 26.7051C11.7913 26.7051 17.729 26.7051 23.6651 26.7051C24.5032 26.7051 25.3414 26.7051 26.1796 26.7051C26.9909 26.7051 26.9909 25.4453 26.1796 25.4453C20.2435 25.4453 14.3058 25.4453 8.36971 25.4453C7.53154 25.4453 6.69337 25.4453 5.8552 25.4453C5.0439 25.4453 5.04222 26.7051 5.8552 26.7051Z",
    fill: "url(#magalu)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "magalu",
    x1: 5.85499,
    y1: 26.0747,
    x2: 26.1794,
    y2: 26.0747,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBE53B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1682,
    stopColor: "#FF4F01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3513,
    stopColor: "#FF14B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#8000FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#00C1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9962,
    stopColor: "#17F036"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagalu);
export default __webpack_public_path__ + "static/media/magalu.d5a3bf5b78a67d7be2bdbc3ef384d783.svg";
export { ForwardRef as ReactComponent };